export default "__VITE_ASSET__9f5baeed__"